import React from "react";

const ca_default_by_merchant = {
  //WelcomeBack messages:
  PROPOSAL_DETAILS: "Proposta enviada a $v1 per un import de $v2€",
  PROPOSAL_DETAILS_WITHOUT_AMOUNT: "Proposta enviada a $v1",

  //Benvinguda
  INVITATION_MSG:
    "Estàs a punt de començar el procés de sol·licitud del teu client $v1",
  NIE_EU_PASSPORT:
    "En cas de tenir NIE Europeu sense foto, demanarem el passaport del teu client.",
  INCOME: "Ingressos",
  SPANISH_ACCOUNT_DETAIL:
    "S'haurà de carregar el document d'ingressos (nòmina, pensió o altres) i un justificant de titularitat del compte bancari del teu client",
  YOUR_LOAN_PROCESS:
    "Així serà el procés de sol·licitud per finançar el teu client",
  LOAN_ADJUSTMENT_AND_EVALUATION: "Avaluació de la sol·licitud del teu client",

  //KYC Manual:
  DOCUMENT_TYPE: "Tipus de document del teu client",
  NAME_SURNAME: "Nom i cognoms del teu client",
  BIRTH_DATA: "Dades de naixement del teu client",
  IMAGE_ID: "Foto del document del teu client",

  //Informació addicional
  IMAGE_ID_NIE_EU: "Foto del passaport del teu client",
  CURRENT_RESIDENCE_ADDRESS: "Adreça actual de residència del teu client",
  ADDRESS_DIALOG_TITLE: "Adreça actual de residència del teu client",
  HOME_INFO: "Dades del domicili actual del teu client",
  MY_CURRENT_ADDRESS_IS: "El domicili actual del client és",
  YOUR_PART: "(part proporcional)",
  FAMILY_SITUATION: "Situació familiar del teu client",
  OWNERSHIP: "De la seva propietat",

  //Ingressos declarats:
  PROVIDE_MAIN_INCOME_SOURCE:
    "Indica la principal font d'ingressos del teu client",
  DIRECT_DEBIT_ACCOUNT: "Domiciliació del teu client",
  BANK_ACCOUNT_IBAN: "Compte de domiciliació del teu client",

  //Dades professionals:
  EMPLOYMENT_STATUS: "Situació laboral del teu client",
  COMPANY_INFO: "Dades de la companyia on treballa el teu client",

  //Resum i ajustaments:
  YOUR_LOAN_RESULT: "El procés està a punt de finalitzar!",
  APPLY_FOR_LOAN_BODY:
    "La sol·licitud no és vinculant fins que el teu client no signi el contracte digitalment. Rebrà un correu electrònic amb les instruccions per completar aquest pas.",
  DATA_TREATMENT: "Tractament de les dades del teu client",
  //Application Info:
  LOAN_ANALYSING: (
    <span>
      <span>
        Hem llançat la sol·licitud del teu client a les entitats financeres i et
        contestarem aviat. Estigues atent!
      </span>

      <p>
        <span>
          Pots tancar aquesta finestra i reprendre el procés quan les entitats
          financeres analitzin la sol·licitud.
        </span>
        <p>
          Pots tornar a obrir la sol·licitud des de la pantalla de detall de
          l'operació.
        </p>
      </p>
    </span>
  ),
  PLEASE_WAIT_APPLICATION:
    "Si us plau espera un moment, estem processant la sol·licitud del teu client. Aquest procés pot durar fins a 1 minut.",

  //Documentació:
  DOCUMENTATION_UPLOAD:
    "Si us plau, puja els següents documents del teu client",

  //Missatges d'informació de sol·licituds
  RESUME_LOAN_PROCESS: "Continua el procés on ho vas deixar.",
  THANKS_LOAN_FORM_COMPLETED_AND_PREAPPROVED:
    "La sol·licitud del teu client ha estat aprovada i està pendent de validació!",
  DOCS_PENDING_INFO:
    "Puja ara la documentació del teu client per obtenir la confirmació final més ràpidament!",
  SIGNATURE_PENDING_INFO:
    "És necessari que el teu client signi el contracte digitalment.",
  SIGNATURE_PENDING_BY_MAIL_INFO_MESSAGE:
    "El teu client haurà de revisar el seu correu electrònic i signar des de qualsevol dispositiu.",
  LOAN_HAS_BEEN_DENIED: "La sol·licitud del teu client no ha estat aprovada",
  SYSTEM_FAILURE_DETECTION:
    "El perfil del teu client no s'adapta a les polítiques de risc de les entitats financeres col·laboradores.",
};

export default ca_default_by_merchant;
